import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { authApi } from '@/api/auth';
import { auth } from '@/shared/auth/storage';
import { setApiActiveScope } from '@/shared/api/client';
import { buildScopedPath, publicRoutes } from '@/app/routes';

export function SelectScopePage() {
  const nav = useNavigate();
  const [tenantId, setTenantId] = useState<string | null>(null);

  useEffect(() => {
    if (!auth.isAuthed) nav(publicRoutes.login, { replace: true });
  }, [nav]);

  const tenantsQ = useQuery({ queryKey: ['scope', 'tenants'], queryFn: authApi.myTenants });
  const companiesQ = useQuery({
    queryKey: ['scope', 'companies', tenantId],
    queryFn: () => authApi.companiesByTenant(tenantId!),
    enabled: !!tenantId,
  });

  useEffect(() => {
    if (tenantsQ.data && tenantsQ.data.length === 1) setTenantId(tenantsQ.data[0].Id);
  }, [tenantsQ.data]);

  function pick(companyId: string) {
    if (!tenantId) return;
    setApiActiveScope({ tenantId, companyId });
    nav(buildScopedPath('dashboard', { tenantId, companyId }));
  }

  return (
    <div className="cg-auth-wrap">
      <div className="ts-card cg-auth-card" style={{ maxWidth: 520 }}>
        <h1 className="ts-page-title" style={{ marginBottom: 4 }}>Байгууллага сонгох</h1>
        <p className="ts-page-sub" style={{ marginBottom: 18 }}>Ажиллах tenant болон компаниа сонгоно уу.</p>

        <label className="ts-label">Tenant</label>
        <select
          className="ts-select"
          value={tenantId ?? ''}
          onChange={(e) => setTenantId(e.target.value || null)}
          style={{ marginBottom: 16 }}
        >
          <option value="">— сонгох —</option>
          {tenantsQ.data?.map((t) => (
            <option key={t.Id} value={t.Id}>
              {t.Name}
            </option>
          ))}
        </select>

        {tenantId && (
          <>
            <label className="ts-label">Компани</label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {companiesQ.data?.map((c) => (
                <button key={c.Id} className="ts-btn" style={{ justifyContent: 'space-between' }} onClick={() => pick(c.Id)}>
                  <span>
                    <i className="bi bi-building" /> {c.Name}
                  </span>
                  <i className="bi bi-chevron-right" />
                </button>
              ))}
              {companiesQ.data && !companiesQ.data.length && (
                <div className="ts-page-sub">Энэ tenant-д компани алга.</div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
